import reduce from './reduce';

/**
 * @param {function} xform
 * @param {function} fn
 * @param {any} init
 * @param {any} coll
 * @returns {any}
 */
function transduce(xform, fn, init, coll) {
  return reduce(xform(fn), init, coll);
}

export default transduce;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/fp/transduce.js
// module id = 296
// module chunks = 0